import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { FormControl } from "baseui/form-control";
import { Input } from "baseui/input";
import { Button } from "baseui/button";
import { Checkbox } from "baseui/checkbox";
import {
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter,
	ModalButton,
} from "baseui/modal";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import request from "../../utils/http";

const JobCodeAdmin = () => {
	const urlParams = useParams() as any;
	const { jobCodeId } = urlParams;
	const isEditMode = !!jobCodeId;
	const navigate = useNavigate();

	const [code, setCode] = useState("");
	const [name, setName] = useState("");
	const [active, setActive] = useState(true);

	useEffect(() => {
		// Fetch the job code details based on the 'id' parameter when the component mounts
		if (jobCodeId) {
			// Fetch job code details for the given 'id' and populate the state variables.
			// Implement this part based on the API.
			const fetchJobCode = async () => {
				try {
					const result = await request(
						"GET",
						`/api/admin/jobcode/${jobCodeId}`,
						null
					);
					if (result.success && result.data) {
						const { jobCode, jobCodeName, active } = result.data;
						setCode(jobCode);
						setName(jobCodeName);
						setActive(active);
					} else {
						// Handle error when fetching job code details.
					}
				} catch (error) {
					// Handle error loadingg job codes.
				}
			};
			fetchJobCode();
		}
	}, [jobCodeId]);

	const saveJobCode = async () => {
		try {
			if (!code || !name) {
				toast.error("Code and Name are required.");
				return;
			}

			const requestData = {
				JobCode: code,
				JobCodeName: name,
				Active: active,
			};

			let result;

			if (isEditMode) {
				// Update existing job code
				result = await request(
					"PUT",
					`/api/admin/jobcode/update/${jobCodeId}`,
					requestData
				);
			} else {
				// Create a new job code
				result = await request(
					"POST",
					`/api/admin/jobcode/create`,
					requestData
				);
			}

			if (result.success) {
				toast.success(
					isEditMode
						? "Job Code updated successfully"
						: "Job code created successfully."
				);
				navigate(`/job-codes`);
			} else {
				toast.error(
					isEditMode ? "Error updating job code" : "Error creating job code"
				);
			}
		} catch (error) {
			// Handle error saving job code.
		}
	};

	const handleCancel = () => {
		navigate(`/job-codes`);
	};

	return (
		<>
			<h1>{isEditMode ? "Edit Job Code" : "Create Job Code"}</h1>
			<div>
				<FormControl label={"Code"}>
					<Input
						value={code}
						onChange={(e) => setCode(e.currentTarget.value)}
					/>
				</FormControl>
				<FormControl label={"Name"}>
					<Input
						value={name}
						onChange={(e) => setName(e.currentTarget.value)}
					/>
				</FormControl>
				{isEditMode && (
					<FormControl label={"Active"}>
						<Checkbox checked={active} onChange={() => setActive(!active)} />
					</FormControl>
				)}
				<div>
					{isEditMode ? (
						<>
							<Button onClick={saveJobCode}>Save</Button>
						</>
					) : (
						<Button onClick={saveJobCode}>Create</Button>
					)}
					&nbsp;
					<Button onClick={handleCancel} kind="secondary">
						Cancel
					</Button>
				</div>
			</div>
		</>
	);
};

export default JobCodeAdmin;
